import {
  CircularProgress,
  Navbar,
  NavbarLayout,
  i18nCore,
  useIsFetching,
  useIsInitLoading,
  useUser,
} from '@core-frontend/core-frontend';
import type { NavbarMenuItem } from '@core-frontend/core-frontend';
import { AdminPanelSettings as AdminPanelSettingsIcon } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { AppRoutes } from '@/app/app-router';

import { LogoutButton } from '@/entities/session';

import { ProbitLogo } from './logo';

const AuthenticatedLayoutWithNavbar = () => {
  const userInfo = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const isLoading = useIsInitLoading();
  const isFetching = useIsFetching();
  const { t } = useTranslation('navMenu');

  const navbarMenuItems: NavbarMenuItem[] = [
    {
      title: t('Navbar.Administration', { defaultValue: 'ADMINISTRATION' }),
      onClick: () => navigate(AppRoutes.HOME),
      isActive:
        location.pathname.includes(AppRoutes.HOME) &&
        !location.pathname.includes(AppRoutes.HRM),
    },
    {
      title: t('Navbar.HRM', { defaultValue: 'HRM' }),
      onClick: () => navigate(AppRoutes.HRM),
      isActive: location.pathname.includes(AppRoutes.HRM),
    },
  ];

  return (
    <NavbarLayout
      companyName="PRO-BIT"
      logoIcon={ProbitLogo}
      menuItems={navbarMenuItems}
      isLoading={isLoading || isFetching}
      profileMenu={
        <Navbar.Profile>
          <Navbar.ProfileInfo
            title={`${userInfo?.user?.first_name} ${userInfo?.user?.last_name}`}
            subtitle={userInfo?.user?.email}
            onClick={() => navigate(AppRoutes.USER_ME)}
          />
          <Navbar.ProfileDivider />
          <Navbar.ProfileMenuButton
            sx={{
              width: '100%',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              px: 2,
              gap: 1,
              textTransform: 'none',
            }}
            variant="text"
            onClick={() => navigate(AppRoutes.PERMISSIONS_MY)}
          >
            <AdminPanelSettingsIcon fontSize="small" />
            {t('ProfileMenu.MyPermissions', {
              defaultValue: 'My permissions',
            })}
          </Navbar.ProfileMenuButton>
          <Navbar.ProfileMenuButton
            onClick={() => {
              i18nCore.changeLanguage('en-US');
            }}
          >
            ENGLISH
          </Navbar.ProfileMenuButton>
          <Navbar.ProfileMenuButton
            onClick={() => {
              i18nCore.changeLanguage('sl-SI');
            }}
          >
            SLO
          </Navbar.ProfileMenuButton>
          <Navbar.ProfileDivider />
          <LogoutButton />
        </Navbar.Profile>
      }
    >
      {isLoading || isFetching ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: 'calc(100vh - 64px)',
          }}
        >
          <CircularProgress size={240} indicatorColor="#EBEBEB" />
        </Box>
      ) : (
        <Outlet />
      )}
    </NavbarLayout>
  );
};

export default AuthenticatedLayoutWithNavbar;
